import React from "react";
import {
  Toolbar,
  AppBar,
  Button,
  Typography,
  useMediaQuery,
  MenuItem,
} from "@material-ui/core/";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import MobileNav from "./navbarComponent/MobileNav";

const useStyles = makeStyles((theme) => ({
  toolBarStyle: {
    minHeight: "50px",
    display: "flex",
    justifyContent: "space-between",
    paddingInlineStart: "40px",
    paddingInlineEnd: "40px",
  },
  appBarStyle: {
    boxShadow: "0 0",
    backgroundColor: "white",
  },
  offset: theme.mixins.toolbar,
  navBtn: {
    margin: "0 2rem",
  },
}));

export default function Navbar() {
  const theme = useTheme();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const buttons = [
    { title: "About us", to: "/about" },
    { title: "Community", to: "/community" },
    { title: "Code of Conduct", to: "/coe" },
  ];
  const renderButtons = (mobile) => {
    return buttons.map((item, index) => {
      return (
        <React.Fragment key={index}>
          <Link style={{ textDecoration: "none" }} to={item.to}>
            <Button
              className={classes.navBtn}
              variant="contained"
              color="secondary"
            >
              {item.title}
            </Button>
          </Link>
        </React.Fragment>
      );
    });
  };

  return (
    <>
      <AppBar className={classes.appBarStyle} position="static">
        <Toolbar className={classes.toolBarStyle}>
          <div>
            <Link to="/3688website/" style={{ textDecoration: "none" }}>
              <Typography color="primary" variant="h6">
                <b>F P S</b>
              </Typography>
            </Link>
          </div>
          <div>
            {isMobile ? (
              <MobileNav>
                {buttons.map((item, index) => {
                  return (
                    <div key={index}>
                      <Link style={{ textDecoration: "none" }} to={item.to}>
                        <MenuItem>{item.title}</MenuItem>
                      </Link>
                    </div>
                  );
                })}
              </MobileNav>
            ) : (
              renderButtons()
            )}
          </div>
        </Toolbar>
      </AppBar>
    </>
  );
}
